import { useProdDate } from './use-query-states'
import { useWeekends } from '@/api/weekends/work-schedules'
import { useWorkSchedules } from '@/api/work-schedules/work-schedules'
import { parseApiDateOnly } from '@/lib/utils'

export const useDisabledDays = () => {
  const { date } = useProdDate()

  const { data: weekends, isLoading } = useWeekends({
    year: date.getFullYear()?.toString()
  })

  const { data: schedules, isLoading: isScheduleLoading } = useWorkSchedules()

  const disabledWorkingDays =
    schedules
      ?.map((s) => (s.weekend ? Number(s.day_of_week) : null))
      .filter((day): day is number => day !== null && !isNaN(day))
      .map((day) => day % 7) ?? []

  const disabledWeekends = (weekends ?? []).map((weekend) => ({
    from: parseApiDateOnly(weekend.start_date),
    to: parseApiDateOnly(weekend.end_date)
  }))

  const isSameOrBetween = (date: Date, from: Date, to: Date) => {
    const d = new Date(date.getFullYear(), date.getMonth(), date.getDate())
    const f = new Date(from.getFullYear(), from.getMonth(), from.getDate())
    const t = new Date(to.getFullYear(), to.getMonth(), to.getDate())
    return d >= f && d <= t
  }

  const isDayDisabled = (day: Date) => {
    for (const rule of disabledWeekends) {
      if (rule.from && rule.to) {
        if (isSameOrBetween(day, rule.from, rule.to)) return true
      }
    }
    if (disabledWorkingDays.includes(day.getDay())) return true
    return false
  }

  return {
    disabledDays: disabledWeekends,
    disabledDayOfWeek: disabledWorkingDays,
    isDayDisabled,
    isLoading: isLoading || isScheduleLoading
  }
}
